module.exports = __webpack_public_path__ + "static/media/kick_off_fall_2023.40a767c7.PNG";